module.exports = __webpack_public_path__ + "img/1574697188.28083cf3.jpg";